import styled from "styled-components";

const StyledHeader = styled.h1``;

const Header = ({ content }) => {
  return <StyledHeader id={content.uuid}>{content.data.text}</StyledHeader>;
};

export default Header;
